var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9614 8.14095C21.0614 7.64095 20.6614 7.04095 20.1614 7.04095L14.4614 6.24095L11.8614 1.04095C11.7614 0.840954 11.6614 0.740954 11.4614 0.640954C10.9614 0.340954 10.3614 0.540954 10.0614 1.04095L7.56143 6.24095L1.86143 7.04095C1.56143 7.04095 1.36143 7.14095 1.26143 7.34095C0.861426 7.74095 0.861426 8.34095 1.26143 8.74095L5.36143 12.741L4.36143 18.441C4.36143 18.641 4.36143 18.841 4.46143 19.041C4.76143 19.541 5.36143 19.741 5.86143 19.441L10.9614 16.741L16.0614 19.441C16.1614 19.541 16.3614 19.541 16.5614 19.541C16.6614 19.541 16.6614 19.541 16.7614 19.541C17.2614 19.441 17.6614 18.941 17.5614 18.341L16.5614 12.641L20.6614 8.64095C20.8614 8.54095 20.9614 8.34095 20.9614 8.14095Z",
    fill: "url(#paint0_linear_101_25)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_101_25",
    x1: 3.96143,
    y1: 3.5,
    x2: 21.4921,
    y2: 14.1665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED462F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star_icon.5dbb514a034006ee7b5ebd8ba8215199.svg";
export { ForwardRef as ReactComponent };